interface TestLocationAccessibilityAction {
  type: 'TEST_LOCATION_ACCESSIBILITY';
  deviceId: string;
  isAccessible: boolean;
}

/**
 * Redux action to test if the location is accessible locally
 */
export function TestLocationAccessibility(
  deviceId: string,
  isAccessible: boolean,
): TestLocationAccessibilityAction {
  return {
    type: 'TEST_LOCATION_ACCESSIBILITY',
    deviceId,
    isAccessible,
  };
}

export type LocationReduxActions = TestLocationAccessibilityAction;
